import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import {
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/shared/ui/dropdown-menu';

const LANGUAGES: readonly { readonly code: string; readonly labelKey: string }[] = [
  { code: 'de', labelKey: 'languages.de' },
  { code: 'en', labelKey: 'languages.en' },
];

/** Sprachauswahl als Untermenü — wiederverwendbar in jedem DropdownMenu. */
export function LanguageSubMenu(): React.JSX.Element {
  const { t, i18n } = useTranslation();

  const changeLanguage = (code: string): void => {
    void i18n.changeLanguage(code);
  };

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger className="cursor-pointer py-2.5">
        <Globe className="mr-2 h-4 w-4 text-muted-foreground" />
        <span>{t('profile.language')}</span>
      </DropdownMenuSubTrigger>
      <DropdownMenuPortal>
        <DropdownMenuSubContent className="min-w-[120px]">
          {LANGUAGES.map(({ code, labelKey }) => {
            const isActive: boolean = i18n.language.startsWith(code);
            return (
              <DropdownMenuItem
                key={code}
                onClick={() => {
                  changeLanguage(code);
                }}
                className="cursor-pointer py-2"
              >
                <span className={isActive ? 'font-bold' : ''}>{t(labelKey)}</span>
                {isActive && <span className="ml-auto w-2 h-2 rounded-full bg-primary" />}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuSubContent>
      </DropdownMenuPortal>
    </DropdownMenuSub>
  );
}
